import * as React from 'react';

function Bowls(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3a9 9 0 110 18 9 9 0 010-18zM6.118 6.586c-1.872 3.241-.312 7.614 3.444 9.783 3.757 2.169 8.324 1.333 10.195-1.908 1.871-3.242.311-7.615-3.445-9.783C12.556 2.51 7.99 3.344 6.118 6.585zm6.394-2.34l-.092.013c-1.3.197-2.442.89-3.091 2.015-1.243 2.153-.215 5.073 2.296 6.522 2.511 1.45 5.554.881 6.797-1.271.665-1.152.679-2.523.165-3.77 1.357 1.975 1.637 4.398.52 6.33-1.65 2.858-5.751 3.608-9.17 1.634-3.418-1.973-4.82-5.901-3.17-8.758 1.116-1.933 3.355-2.902 5.745-2.715zM15.375 6.3c1.393.805 2.134 2.305 1.473 3.449-.66 1.145-2.33 1.252-3.723.448-1.393-.803-2.134-2.304-1.473-3.448.66-1.144 2.33-1.253 3.723-.449z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Bowls;
